import { useUser } from 'containers/App/context/useUser';
import { useMemo, useState } from 'react';
import { Cart } from './types';
import { useGetPlans } from 'queries/plan/useGetPlans';
import { useCreatePaymentLink } from 'queries/payments/useCreatePaymentLink';
import { useBillingInfos } from 'queries/useBillingInfos';
import { Plan } from 'types/plan';
import { Payment } from 'types/user';

export interface UseSubscriptionPropsReturn {
  cart: Cart;
  setCart: (cart: Cart) => void;
  subscribablePlans: Plan[];
  isCheckoutDisabled: boolean;
  isLoading: boolean;
  isCheckoutLoading: boolean;
  onCheckout: () => Promise<void>;
  paymentHistory: Payment[];
}

export function useSubscriptionProps(): UseSubscriptionPropsReturn {
  const user = useUser();
  const [cart, setCart] = useState<Cart>({
    essentielQuantity: 0,
    integralQuantity: 4,
  });
  const { data: plans, isLoading: isLoadingPlans } = useGetPlans(user.locale);
  const checkout = useCreatePaymentLink();

  const { isLoading: isLoadingBillingInfo, data: billingInfos } =
    useBillingInfos();

  const subscribablePlans =
    plans !== undefined ? plans.filter(p => p.id !== 'free') : [];

  const paymentHistory = useMemo(
    () => (billingInfos?.paymentHistory || []).filter(p => p.amount > 100),
    [billingInfos?.paymentHistory],
  );
  const minQuantity = paymentHistory.length > 0 ? 1 : 2;
  const isLicenceQuantityBelowMin =
    cart.integralQuantity + cart.essentielQuantity < minQuantity;

  return {
    cart,
    setCart,
    subscribablePlans,
    isCheckoutDisabled: isLicenceQuantityBelowMin,
    isLoading: isLoadingBillingInfo || isLoadingPlans,
    isCheckoutLoading: checkout.isPending,
    onCheckout: () => checkout.mutateAsync(cart),
    paymentHistory,
  };
}
